// 国际海运
export const SeaFreightZh = {
  // 中文
  DataStatistics: '数据统计',
  CurrentMonth: '当月度',
  CurrentQuarter: '当季度',
  CurrentYear: '当年度',
  ServiceType: '业务类型',
  Category: '运输模式',
  FreightExport: '海运出口',
  FreightImport: '海运进口',
  WaterTransport: '内贸水运',
  BLofShipment: '业务数量',
  FCL_TEU: '整箱-箱量',
  LCL_CBM: '拼箱-体积',
  BookingPlaced: '已订舱',
  CustomsDeclared: '已报关',
  VesselDeparted: '已开航',
  ShipmentStatistics: '业务统计',
  RouteBL: '航线 (票)',
  MiddleEastIndiaSubRoute: '中东印巴线',
  SouthCentralAmericaRoute: '中南美线',
  EU_MediterraneanRoute: '欧地',
  JapanSKoreaTaiwanRoute: '日韩台湾线',
  SouthEastAsiaRoute: '东南亚',
  TransPacificRoute: '美加',
  TEUCBMStatistics: '箱量/体积统计',
  RouteTEUCBM: '航线 (箱量/体积)',
  Disclaimer: '免责声明：尊敬的客户，本页面显示的业务相关数据信息，因存在业务量动态变化以及信息更新滞后等情况，仅供参考，无法律约束力。最终信息，以双方书面确认为准，感谢理解与配合。',
  BookingQuery: '订单查询',
  SubscriptionCenter: '订阅中心',
  MWJobNo: '我司编码',
  CustomerCode: '客户编码',
  RangeofBooking: '下单区间',
  YearMonthDay: '（年月日）',
  MBHBNo: '主/分单号',
  TypeofEquipment: '箱型',
  ContainerNumber: '箱号',
  PleaseFillinContents: '请输入内容',
  Query: '查询',
  Reset: '重置',
  Export: '导出',
  ViewDetails: '明细查看',
  BookingNumber: '订单号',
  DateofBooking: '下单时间',
  Collapse: '收起',
  PortofLoadingDetails: '起运港信息',
  PortofLoading: '起运港',
  TotalNumberOfPackage: '总件数',
  GrossWeight: '毛重',
  CBM: '体积',
  PortofDestinationDetails: '目的港信息',
  PortofDestination: '目的港',
  DescriptionofGoods: '品名',
  ShipmentDetails: '货物信息',
  EquipmentTypeandTEU: '箱型箱量',
  DownloadAttachment: '下载附件',
  BookingConfirmation: '订舱确认',
  GateinTime: '进港时间',
  CustomsRelease: '海关放行',
  LoadingTime: '配载时间',
  DepartureDate: '开航日期',
  Page: '页',
  Tickets: '票',
  ArrivedatPort: '已到港',
  Delivered: '已送货',
  QueryFailed: '查询失败',
  Other: '其它',
  OtherBoxQuantities: '箱量其它',
  VolumeOther: '体积其它',
  To: '至',
  StartTime: '开始时间',
  EndTime: '结束时间',
  SwitchToList: '切换为列表模式',
  SwitchToCard: '切换为卡片模式',
  DeliveryNoteNumber: '提货单号',
  DeliveryAddressInformation: '送货地址信息',
  DeliveryAddress: '送货地',
  TEU: '箱量',
  SerialNumber: '序号',
  OrderStatus: '订单状态',
  ReceivingOrders: '接单',
  DeliveryDate: '送货日',
  NumberOfPieces: '件数',
  Unit: '单位',
  ImportOrderDetails: '进口订单详情',
  ExportOrderDetails: '出口订单详情',
  DeliverGoods: '送货',
  BoxType: '箱类型',
  CFSAttachments: 'CFS附件',
  Operate: '操作',
  BookingSpace: '订舱',
  MBLNo: '主单号',
  HBLNo: '分单号',
  Sail: '开航',
  PreStowage: '配载',
  Arrival: '进港',
  Loaded: '装箱',
  Inbound: '入库',
  SelectAll: '全选',
  DeselectAll: '取消全选',
  BatchDownload: '批量下载',
  Close: '关闭',
  ImageLoading: '图片加载中…',
  Check: '勾选',
  Download: '下载',
  FileName: '文件名',
  Cancel: '取消',
  Preview: '预览',
  ETD: '预计开航',
  ATD: '实际开航',
  ETA: '预计到达',
  Code: '编码',
  Name: '名称',
  seaport: 'seaportName',
}

export const SeaFreightEn = {
  // 英文
  DataStatistics: 'Dashboard',
  CurrentMonth: 'Current Month',
  CurrentQuarter: 'Current Quarter',
  CurrentYear: 'Current Year',
  ServiceType: 'Job Type',
  Category: 'Category',
  FreightExport: 'Ocean Export',
  FreightImport: 'Ocean Import',
  WaterTransport: 'Multimodal Transport',
  BLofShipment: 'Ttl Shipment',
  FCL_TEU: 'FCL (TEU)',
  LCL_CBM: 'LCL (CBM)',
  BookingPlaced: 'Booked',
  CustomsDeclared: 'Customs Declared',
  VesselDeparted: 'Vessel Departed',
  ShipmentStatistics: 'Shipment',
  RouteBL: 'Route (B/L)',
  MiddleEastIndiaSubRoute: 'Middle East & India sub Route',
  SouthCentralAmericaRoute: 'South & Central America Route',
  EU_MediterraneanRoute: 'EU & Mediterranean Route',
  JapanSKoreaTaiwanRoute: 'Japan/S. Korea & Taiwan Route',
  SouthEastAsiaRoute: 'South East Asia Route',
  TransPacificRoute: 'Trans Pacific Route',
  TEUCBMStatistics: 'TEU/CBM',
  RouteTEUCBM: 'Route (TEU/CBM)',
  Disclaimer: 'Disclaimer:  The relevant information displayed on this page is for your reference only. The final information is subject to written confirmation by both parties.',

  BookingQuery: 'Tracking',
  SubscriptionCenter: 'Subscription',
  MWJobNo: 'MW No.',
  CustomerCode: 'Your Ref No.',
  RangeofBooking: 'Booking Date',
  YearMonthDay: '(Year/Month/Day)',
  MBHBNo: 'M/HBL No',
  TypeofEquipment: 'CNTR Type',
  ContainerNumber: 'Container No.',
  PleaseFillinContents: 'Please fill in the contents',
  Query: 'Search',
  Reset: 'Reset',
  Export: 'Export',
  ViewDetails: 'Details',
  BookingNumber: 'MW No.',
  DateofBooking: 'Booking Date',
  EquipmentType: 'Equipment Type',
  Collapse: 'Collapse',
  PortofLoadingDetails: 'Port of Loading',
  PortofLoading: 'POL',
  TotalNumberOfPackage: 'Total PKGS',
  GrossWeight: 'GW',
  CBM: 'VOL',
  PortofDestinationDetails: 'Port of Destination',
  PortofDestination: 'POD',
  DescriptionofGoods: 'Goods',
  ShipmentDetails: 'Container',
  EquipmentTypeandTEU: 'Container QTY',
  DownloadAttachment: 'Download',
  BookingConfirmation: 'Carrier Booked',
  GateinTime: 'Gate-in Time',
  CustomsRelease: 'Customs Release',
  LoadingTime: 'Loading Time',
  DepartureDate: 'ETD',
  Page: 'Page',
  Tickets: 'Tickets',
  ArrivedatPort: 'Arrived at Port',
  Delivered: 'Delivered',
  QueryFailed: 'Query Failed',
  Other: 'Other',
  OtherBoxQuantities: 'Other Box Quantities',
  VolumeOther: 'Volume Other',
  To: 'To',
  StartTime: 'Start Time',
  EndTime: 'End Time',
  SwitchToList: 'Switch',
  SwitchToCard: 'Switch',
  DeliveryNoteNumber: 'MBL No.',
  DeliveryAddressInformation: 'Delivery Address',
  DeliveryAddress: 'Delivery To',
  TEU: 'TEU',
  SerialNumber: 'Number',
  OrderStatus: 'Status',
  ReceivingOrders: 'Order Recieved',
  DeliveryDate: 'Delivery Date',
  NumberOfPieces: 'Pieces',
  Unit: 'Unit',
  ImportOrderDetails: 'Import Order Details',
  ExportOrderDetails: 'Export Order Details',
  DeliverGoods: 'Deliver Goods',
  BoxType: 'Load Type',
  CFSAttachments: 'CFS Attachments',
  Operate: 'ATT',
  BookingSpace: 'Booking Space',
  MBLNo: 'MBLNo',
  HBLNo: 'HBLNo',
  Sail: 'Sail',
  PreStowage: 'Pre Stowage',
  Arrival: 'Arrival',
  Loaded: 'Loaded',
  Inbound: 'Inbound',
  SelectAll: 'Select All',
  DeselectAll: 'Deselect All',
  BatchDownload: 'Batch Download',
  Close: 'Close',
  ImageLoading: 'Image Loading…',
  Check: 'Check',
  Download: 'Download',
  FileName: 'File Name',
  Cancel: 'Cancel',
  Preview: 'Preview',
  ETD: 'ETD',
  ETA: 'ETA',
  ATD: 'ATD',
  Code: 'Code',
  Name: 'Name',
  seaport: 'seaportName',
}
